module.exports = __webpack_public_path__ + "static/img/team-img-bg.995db0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team-img-bg.png
// module id = ZRVw
// module chunks = 1